import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../services/selectors";
import { getCookie } from "../../utils/cookie";
import { useDispatch } from "react-redux";
import Loader from "../loader/loader";
import { getMe } from "../../utils/api";
import { START_LOADING, END_LOADING } from "../../services/actions/loading_actions";
import { REQUEST_GET_ME_SUCCESS, REQUEST_GET_ME_FAILED } from "../../services/actions/user_actions";
import { TITLE_ERROR } from "../../utils/constants";
import { SET_PORTAL_API } from "../../services/actions/portal_actions";


function ProtectedRoute({ element }) {

  const user = useSelector(getUser);
  const location = useLocation();

  let accessToken = getCookie('accessToken') || '';
  let refreshToken = getCookie('refreshToken') || '';

  const dispatch = useDispatch();

  const [waitUser, setWaitUser] = useState(user?.id ? false : true)


  useEffect(() => {
    if (waitUser && (accessToken && refreshToken)) {
      dispatch({ type: START_LOADING });
      getMe(accessToken, refreshToken)
        .then(data => {
          dispatch({
            type: REQUEST_GET_ME_SUCCESS,
            id: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            surname: data.surname,
            email: data.email,
            phone: data.phone,
            is_active: data.is_active,
            discount_level: data.discount_level,
            role: data.role,
            perm_news: data.perm_news,
            perm_system_messages: data.perm_system_messages,
            last_ship_name: data.last_ship_name,
            last_ship_description: data.last_ship_description,
            pre_last_ship_name: data.pre_last_ship_name,
            pre_last_ship_description: data.pre_last_ship_description
          });
          setWaitUser(false);
        })
        .catch(error => {
          dispatch({ type: REQUEST_GET_ME_FAILED });
          console.log(error);
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_ERROR,
            text: Object.values(error)
          });
        })
        .finally(() => {
          dispatch({ type: END_LOADING });
        });
    } else {
      setWaitUser(false);
    }
    // eslint-disable-next-line
  }, []);


  return (
    <>
      {waitUser ? <Loader /> :
        (user.loggedIn && user.is_active) ? element : <Navigate to="/login" replace state={{ from: location }} />
      }
    </>
  );


}

export default ProtectedRoute;
